import React from 'react';
import SvgIcon from './SvgIcon';

const MessageActive = props => (
    <SvgIcon viewBox="0 0 18 16" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill="#3777BC" fillRule="nonzero" transform="translate(-723 -676)">
                <g transform="translate(678 589)">
                    <g transform="translate(42 83)">
                        <g transform="translate(3 4.5)">
                            <path d="M17.25 0H.75C.3 0 0 .3 0 .75V3c0 .3.15.525.375.675l8.25 4.5c.15.075.225.075.375.075s.225 0 .375-.075l8.25-4.5A.788.788 0 0018 3V.75c0-.45-.3-.75-.75-.75z"></path>
                            <path d="M10.05 9.45c-.3.225-.675.3-1.05.3s-.75-.075-1.05-.3L0 5.175v9.075c0 .45.3.75.75.75h16.5c.45 0 .75-.3.75-.75V5.175L10.05 9.45z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

MessageActive.displayName = 'MessageActiveIcon';

export default MessageActive;
